import { Modal } from '../modal';
import { Button } from '../button';
import styles from './DeleteConfirmModal.module.css';

export interface DeleteConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  itemType: string;
  itemName: string;
  loading?: boolean;
}

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  itemType,
  itemName,
  loading = false,
}: DeleteConfirmModalProps) => (
  <Modal
    open={open}
    onClose={onClose}
    title={`Delete ${itemType}`}
    size="sm"
    closeOnBackdrop={false}
    footer={
      <div className={styles.footer}>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button className={styles.deleteBtn} variant="primary" onClick={onConfirm} loading={loading}>
          Delete
        </Button>
      </div>
    }
  >
    <p className={styles.message}>
      Are you sure you want to delete {itemType}{' '}
      <strong>"{itemName}"</strong>? This action cannot be undone.
    </p>
  </Modal>
);

export { DeleteConfirmModal };
